import { Phone, PhoneSlash, PhoneX, XCircle, X, Clock, ClockCountdown, Star, Trophy, GlobeHemisphereWest, Voicemail, ChatCircleText, Handshake, UserFocus, Buildings, DoorOpen, Prohibit } from "@phosphor-icons/react";

// Coordonnées Digital Corp France — affichées dans l'encart upsell "Site web"
export const DCF = {
  contact: "Damien Stego",
  phone: "06 30 28 95 74",
  email: "digitalcorpfrance@gmail.com",
  website: "digitalcorpfrance.com",
  website_url: "https://www.digitalcorpfrance.com",
  address: "9 rue André Koechlin-Dollfus, 68200 Mulhouse",
};

// Statuts d'appel (Phase 1 — élargis pour distinguer tentative/contact + boucle terrain)
export const STATUSES = [
  // --- État initial ---
  { id: "to_call",          label: "À appeler",       short: "À appeler",   color: "bg-muted text-foreground border-border", rowBg: "", icon: Phone },
  // --- Tentatives sans contact humain ---
  { id: "no_answer",        label: "Pas joint",       short: "Pas joint",   color: "bg-muted-foreground/10 text-muted-foreground border-muted-foreground/30", rowBg: "bg-muted/30", icon: PhoneSlash },
  { id: "voicemail",        label: "Messagerie",      short: "Messagerie",  color: "bg-slate-500/15 text-slate-600 border-slate-400/40", rowBg: "bg-slate-500/5", icon: Voicemail },
  // --- Contact humain — sans opportunité immédiate ---
  { id: "contact_reached",  label: "Contact établi",  short: "Contact",     color: "bg-blue-500/15 text-blue-700 border-blue-400/40", rowBg: "bg-blue-500/5", icon: ChatCircleText },
  { id: "wrong_person",     label: "Mauvais interlocuteur", short: "Mauv. interloc.", color: "bg-amber-500/15 text-amber-700 border-amber-400/40", rowBg: "bg-amber-500/5", icon: UserFocus },
  // --- Contact + opportunité (colle au télépro) ---
  { id: "callback",         label: "Rappeler",        short: "Rappeler",    color: "bg-[#C8795A]/15 text-[#C8795A] border-[#C8795A]/40", rowBg: "bg-[#C8795A]/5", icon: ClockCountdown },
  { id: "interested",       label: "Intéressé",       short: "Intéressé",   color: "bg-[#E0B043]/20 text-[#8a6a14] border-[#E0B043]/50", rowBg: "bg-[#E0B043]/5", icon: Star },
  { id: "meeting",          label: "Rendez-vous pris", short: "RDV",        color: "bg-indigo-500/15 text-indigo-700 border-indigo-400/40", rowBg: "bg-indigo-500/5", icon: Handshake },
  { id: "site_web_besoin",  label: "Besoin site web", short: "Site web",    color: "bg-[#1a5f8a]/15 text-[#1a5f8a] border-[#1a5f8a]/40", rowBg: "bg-[#1a5f8a]/5", icon: GlobeHemisphereWest },
  // --- Conversion finale ---
  { id: "sale",             label: "Vente conclue !", short: "Vente !",     color: "bg-primary/15 text-primary border-primary/50 font-bold", rowBg: "bg-primary/5", icon: Trophy },
  // --- Refus ---
  { id: "refused",          label: "Refus",           short: "Refus",       color: "bg-secondary/15 text-secondary border-secondary/40", rowBg: "bg-secondary/5", icon: XCircle },
  { id: "refused_final",    label: "Refus définitif", short: "Refus déf.",  color: "bg-red-700/15 text-red-800 border-red-700/40", rowBg: "bg-red-700/5", icon: Prohibit },
  // --- Feedback qualité base (nettoie automatiquement) ---
  { id: "wrong_number",     label: "Faux numéro",     short: "Faux num",    color: "bg-rose-500/15 text-rose-700 border-rose-400/40", rowBg: "bg-rose-500/5", icon: PhoneX },
  { id: "closed",           label: "Entreprise fermée", short: "Fermé",     color: "bg-neutral-700/15 text-neutral-700 border-neutral-500/40", rowBg: "bg-neutral-700/5", icon: DoorOpen },
  { id: "see_headquarters", label: "Voir le siège",   short: "Siège",       color: "bg-purple-500/15 text-purple-700 border-purple-400/40", rowBg: "bg-purple-500/5", icon: Buildings },
];

export const STATUS_BY_ID = Object.fromEntries(STATUSES.map((s) => [s.id, s]));
// Statuts qui « verrouillent » la fiche (le télépro l'a traitée)
export const RESOLVED_STATUSES = new Set([
  "no_answer", "voicemail", "contact_reached", "wrong_person",
  "refused", "refused_final", "interested", "meeting", "sale",
  "site_web_besoin", "wrong_number", "closed", "see_headquarters",
]);
// Statuts qui indiquent un contact humain réel (KPI joignabilité)
export const CONTACT_REACHED_STATUSES = new Set([
  "contact_reached", "wrong_person", "callback", "interested",
  "meeting", "site_web_besoin", "sale", "refused",
  "refused_final", "see_headquarters",
]);
// Statuts qui « collent » le prospect au télépro
export const OWNERSHIP_STATUSES = new Set([
  "interested", "meeting", "callback", "site_web_besoin",
]);

// Structured Q1/Q2/Q3 options for the Découverte step — checkbox/radio labels.
export const FOUND_VIA_OPTIONS = [
  { id: "google",           label: "Google" },
  { id: "facebook",         label: "Facebook" },
  { id: "instagram",        label: "Instagram" },
  { id: "bouche_a_oreille", label: "Bouche à oreille" },
  { id: "site_web",         label: "Leur site web" },
  { id: "autre",            label: "Autre" },
];
export const HAS_WEBSITE_OPTIONS = [
  { id: "yes",     label: "Oui" },
  { id: "no",      label: "Non" },
  { id: "unknown", label: "Ne sait pas" },
];
export const INTEREST_OPTIONS = [
  { id: "interested",     label: "Intéressé" },
  { id: "thinking",       label: "À réfléchir" },
  { id: "not_interested", label: "Pas intéressé" },
];

export const PITCH_STEPS = [
  {
    id: "intro",
    label: "Présentation",
    color: "bg-primary",
    body:
      "« Bonjour, [Prénom Nom] de MonCommerce68, l'annuaire local du Haut-Rhin. " +
      "Je vous contacte parce qu'on vient de référencer votre établissement et je voulais " +
      "vous offrir 14 jours d'essai gratuit de la visibilité Premium — sans engagement et sans carte bancaire. " +
      "Vous avez 2 minutes pour que je vous explique ? »",
  },
  {
    id: "discovery",
    label: "Découverte",
    color: "bg-[#C8795A]",
    body:
      "Q1. « Comment vos clients vous trouvent aujourd'hui : bouche-à-oreille, Google, Facebook ? »\n" +
      "Q2. « Vous avez un site internet ou une fiche Google active ? »\n" +
      "Q3. « Si je vous mets en haut de l'annuaire local à partir de 14,99 €/mois — soit 7,50 € la 1ʳᵉ année avec la promo -50 % — ça pourrait vous intéresser ? »",
  },
  {
    id: "pitch",
    label: "Pitch",
    color: "bg-[#E0B043]",
    body:
      "« Voilà ce que vous gagnez en Premium :\n\n" +
      "✅ Logo + galerie photos + description détaillée\n" +
      "✅ Numéro affiché direct + bouton WhatsApp\n" +
      "✅ EN HAUT des résultats de votre catégorie + ville\n" +
      "✅ Badge Partenaire + publication d'actualités\n" +
      "✅ Statistiques mensuelles\n" +
      "✅ 14 jours OFFERTS sans CB\n\n" +
      "👉 Si pas concluant : 0 € payé. Si concluant :\n" +
      "• Premium : 14,99 €/mois (7,50 €/mois la 1ʳᵉ année avec -50 %)\n" +
      "• Premium IA (upsell) : 29,99 €/mois (15 €/mois la 1ʳᵉ année) — IA qui écrit descriptions, posts, réponses avis. »",
  },
  {
    id: "closing",
    label: "Closing",
    color: "bg-secondary",
    body:
      "« Parfait, je vous active ça maintenant. Allez sur moncommerce68.fr → " +
      "Devenir partenaire (en haut à droite). Tout en bas, champ « Code de votre conseiller » " +
      "→ tapez MON CODE (je vous épelle). Vous me confirmez par SMS quand c'est fait ? »",
  },
];

export const OBJECTIONS = [
  { id: "expensive", label: "« Trop cher »",    reply: "Avec la promo -50 % la 1ʳᵉ année, Premium c'est 7,50 €/mois = 25 centimes/jour. UN seul client en plus = rentabilisé. Et 14 jours gratuits sans CB, zéro risque." },
  { id: "notime",    label: "« Pas le temps »", reply: "Justement — on s'occupe de tout. Vous donnez le logo, je crée la fiche en 3 minutes." },
  { id: "think",     label: "« Je réfléchis »", reply: "Réfléchissez EN testant ! 14 jours gratuits, pas de CB demandée. Si ça ne plaît pas, vous arrêtez." },
  { id: "havesite",  label: "« J'ai un site »", reply: "70 % cherchent en local sur Google AVANT de cliquer sur un site. L'annuaire local complète, ne remplace pas." },
  { id: "nosite",    label: "« Pas de site »",  reply: "Justement, votre fiche Premium FAIT office de site internet : photos, horaires, contact direct." },
];
